import IconFaceMask from '@picsart/icons/IconFaceMask';
import IconBlankWrite from '@picsart/icons/IconBlankWrite';
import IconRefresh from '@picsart/icons/IconRefresh';
import IconEmail from '@picsart/icons/IconEmail';
import IconHashtag from '@picsart/icons/IconHashtag';
import IconEmbedCode from '@picsart/icons/IconEmbedCode';
import IconLearn from '@picsart/icons/IconLearn';
import IconEmailHeader from '@picsart/icons/IconEmailHeader';
import IconSketch from '@picsart/icons/IconSketch';
import IconDetails from '@picsart/icons/IconDetails';
import IconJob from '@picsart/icons/IconJob';
import IconPromote from '@picsart/icons/IconPromote';
import IconProfileOutline from '@picsart/icons/IconProfileOutline';
import IconTemplate from '@picsart/icons/IconTemplate';
import IconBookmark from '@picsart/icons/IconBookmark';
import IconCallout from '@picsart/icons/IconCallout';
import IconAssignmentTurnedIn from '@picsart/icons/IconAssignmentTurnedIn';
import IconPoster from '@picsart/icons/IconPoster';
import IconSubtitle from '@picsart/icons/IconSubtitle';
import IconFeedback from '@picsart/icons/IconFeedback';
import IconTemplates from '@picsart/icons/IconTemplates';
import IconDevelop from '@picsart/icons/IconDevelop';
import IconSpacingVertical from '@picsart/icons/IconSpacingVertical';
import IconTextToVideo from '@picsart/icons/IconTextToVideo';
import IconSubtitleSquare from '@picsart/icons/IconSubtitleSquare';
import IconFold from '@picsart/icons/IconFold';
import IconUnfold from '@picsart/icons/IconUnfold';

import { MenuCategory, MenuCategoryType } from '../utils/common/types';

import { MenuCategoryEnum } from './tool-categories';

const GEN_TEXT_MENU_CATEGORY: MenuCategory = {
  type: MenuCategoryType.Generate,
  icon: IconSketch,
  text: 'Generate text',
  subcategories: [
    {
      id: 101,
      category: MenuCategoryEnum.ARTICLE_WRITER_CATEGORY,
      text: 'Article',
      icon: IconDetails,
    },
    { id: 102, category: MenuCategoryEnum.EMAIL_WRITER_CATEGORY, text: 'Email', icon: IconEmail },
    {
      id: 103,
      category: MenuCategoryEnum.ESSAY_WRITER_CATEGORY,
      text: 'Essay',
      icon: IconBookmark,
    },
    { id: 104, category: MenuCategoryEnum.IDEA_GENERATOR_CATEGORY, text: 'Ideas', icon: IconLearn },
    {
      id: 105,
      category: MenuCategoryEnum.KEYWORD_GENERATOR_CATEGORY,
      text: 'Keywords',
      icon: IconSubtitleSquare,
    },
    {
      id: 106,
      category: MenuCategoryEnum.BUSINESS_NAME_CATEGORY,
      text: 'Names',
      icon: IconProfileOutline,
    },
    {
      id: 107,
      category: MenuCategoryEnum.PAGE_OUTLINE_CATEGORY,
      text: 'Outline',
      icon: IconTemplate,
    },
    {
      id: 108,
      category: MenuCategoryEnum.PARAGRAPH_GENERATOR_CATEGORY,
      text: 'Paragraph',
      icon: IconSpacingVertical,
    },
    {
      id: 109,
      category: MenuCategoryEnum.PROMPT_GENERATOR_CATEGORY,
      text: 'Prompt',
      icon: IconDevelop,
    },
    {
      id: 110,
      category: MenuCategoryEnum.VIDEO_SCRIPT_GENERATOR_CATEGORY,
      text: 'Script',
      icon: IconTextToVideo,
    },
    {
      id: 111,
      category: MenuCategoryEnum.STORY_GENERATOR_CATEGORY,
      text: 'Story',
      icon: IconBookmark,
    },
    {
      id: 112,
      category: MenuCategoryEnum.TITLE_GENERATOR_CATEGORY,
      text: 'Titles',
      icon: IconEmailHeader,
    },
    {
      id: 113,
      category: MenuCategoryEnum.TRANSLATOR_CATEGORY,
      text: 'Translations',
      icon: IconCallout,
    },
  ],
};

const EDIT_TEXT_MENU_CATEGORY: MenuCategory = {
  type: MenuCategoryType.Edit,
  icon: IconBlankWrite,
  text: 'Edit text',
  subcategories: [
    {
      id: 200,
      category: MenuCategoryEnum.EXPAND_TEXT_CATEGORY,
      text: 'Expand',
      icon: IconUnfold,
    },
    {
      id: 201,
      category: MenuCategoryEnum.GRAMMAR_CHECKER_CATEGORY,
      text: 'Grammar checker',
      icon: IconAssignmentTurnedIn,
    },
    {
      id: 202,
      category: MenuCategoryEnum.REPHRASER_CATEGORY,
      text: 'Paraphraser',
      icon: IconRefresh,
    },
    {
      id: 203,
      category: MenuCategoryEnum.SHORTEN_TEXT_CATEGORY,
      text: 'Shorten',
      icon: IconFold,
    },
    {
      id: 204,
      category: MenuCategoryEnum.SUMMARIZER_CATEGORY,
      text: 'Summarizer',
      icon: IconPoster,
    },
  ],
};

const CONTENT_MENU_CATEGORY: MenuCategory = {
  type: MenuCategoryType.Content,
  icon: IconDetails,
  text: 'Content',
  subcategories: [
    {
      id: 300,
      category: MenuCategoryEnum.ARTICLE_WRITER_CATEGORY,
      text: 'Article',
      icon: IconDetails,
    },
    {
      id: 301,
      category: MenuCategoryEnum.BLOG_TITLE_GENERATOR_CATEGORY,
      text: 'Blog titles',
      icon: IconLearn,
    },
    {
      id: 302,
      category: MenuCategoryEnum.INSTAGRAM_CAPTION_CATEGORY,
      text: 'Captions',
      icon: IconSubtitle,
    },
    {
      id: 303,
      category: MenuCategoryEnum.INSTAGRAM_HASHTAG_CATEGORY,
      text: 'Hashtags',
      icon: IconHashtag,
    },
    {
      id: 304,
      category: MenuCategoryEnum.CONTENT_IDEA_GENERATOR_CATEGORY,
      text: 'Ideas',
      icon: IconLearn,
    },
    {
      id: 305,
      category: MenuCategoryEnum.KEYWORD_GENERATOR_CATEGORY,
      text: 'Keywords',
      icon: IconSubtitleSquare,
    },
    {
      id: 306,
      category: MenuCategoryEnum.META_DATA_MAKER_CATEGORY,
      text: 'Meta description',
      icon: IconEmbedCode,
    },
    {
      id: 307,
      category: MenuCategoryEnum.PAGE_OUTLINE_CATEGORY,
      text: 'Outline',
      icon: IconTemplate,
    },
    {
      id: 308,
      category: MenuCategoryEnum.PARAGRAPH_GENERATOR_CATEGORY,
      text: 'Paragraph',
      icon: IconSpacingVertical,
    },
    {
      id: 309,
      category: MenuCategoryEnum.VIDEO_SCRIPT_GENERATOR_CATEGORY,
      text: 'Script',
      icon: IconTextToVideo,
    },
    {
      id: 310,
      category: MenuCategoryEnum.SOCIAL_MEDIA_BIO_CATEGORY,
      text: 'Social media bio',
      icon: IconFaceMask,
    },
    {
      id: 311,
      category: MenuCategoryEnum.STORY_IDEA_GENERATOR_CATEGORY,
      text: 'Story ideas',
      icon: IconLearn,
    },
    {
      id: 312,
      category: MenuCategoryEnum.CONTENT_TITLE_GENERATOR_CATEGORY,
      text: 'Titles',
      icon: IconEmailHeader,
    },
    {
      id: 313,
      category: MenuCategoryEnum.VIDEO_TITLE_GENERATOR_CATEGORY,
      text: 'Video titles',
      icon: IconEmailHeader,
    },
  ],
};

const BUSINESS_MENU_CATEGORY: MenuCategory = {
  type: MenuCategoryType.Business,
  icon: IconJob,
  text: 'Business',
  subcategories: [
    {
      id: 400,
      category: MenuCategoryEnum.BUSINESS_NAME_CATEGORY,
      text: 'Business names',
      icon: IconJob,
    },
    {
      id: 401,
      category: MenuCategoryEnum.EMAIL_WRITER_CATEGORY,
      text: 'Email writer',
      icon: IconEmail,
    },
    {
      id: 402,
      category: MenuCategoryEnum.BUSINESS_IDEA_GENERATOR_CATEGORY,
      text: 'Ideas',
      icon: IconLearn,
    },
    {
      id: 403,
      category: MenuCategoryEnum.SIDE_HUSTLE_IDEA_GENERATOR_CATEGORY,
      text: 'Side hustle ideas',
      icon: IconLearn,
    },
    {
      id: 404,
      category: MenuCategoryEnum.MARKETING_SLOGAN_CATEGORY,
      text: 'Slogan',
      icon: IconFeedback,
    },
    {
      id: 405,
      category: MenuCategoryEnum.STARTUP_IDEA_GENERATOR_CATEGORY,
      text: 'Startup ideas',
      icon: IconLearn,
    },
  ],
};

const MARKETING_MENU_CATEGORY: MenuCategory = {
  type: MenuCategoryType.Marketing,
  icon: IconPromote,
  text: 'Marketing',
  subcategories: [
    {
      id: 500,
      category: MenuCategoryEnum.AD_WRITER_CATEGORY,
      text: 'Ad copy',
      icon: IconPoster,
    },
    {
      id: 501,
      category: MenuCategoryEnum.ARTICLE_WRITER_CATEGORY,
      text: 'Article',
      icon: IconDetails,
    },
    {
      id: 502,
      category: MenuCategoryEnum.BLOG_TITLE_GENERATOR_CATEGORY,
      text: 'Blog titles',
      icon: IconEmailHeader,
    },
    { id: 503, category: MenuCategoryEnum.EMAIL_WRITER_CATEGORY, text: 'Email', icon: IconEmail },
    {
      id: 504,
      category: MenuCategoryEnum.KEYWORD_GENERATOR_CATEGORY,
      text: 'Keywords',
      icon: IconSubtitleSquare,
    },
    {
      id: 505,
      category: MenuCategoryEnum.LANDING_PAGE_TITLE_GENERATOR_CATEGORY,
      text: 'Landing page titles',
      icon: IconEmailHeader,
    },
    {
      id: 506,
      category: MenuCategoryEnum.META_DATA_MAKER_CATEGORY,
      text: 'Meta description',
      icon: IconEmbedCode,
    },
    {
      id: 507,
      category: MenuCategoryEnum.PARAGRAPH_GENERATOR_CATEGORY,
      text: 'Paragraph',
      icon: IconSpacingVertical,
    },
    {
      id: 508,
      category: MenuCategoryEnum.PRODUCT_DESCRIPTION_CATEGORY,
      text: 'Product description',
      icon: IconTemplates,
    },
    {
      id: 509,
      category: MenuCategoryEnum.MARKETING_SLOGAN_CATEGORY,
      text: 'Slogan',
      icon: IconFeedback,
    },
  ],
};

export const MENU_CATEGORIES: MenuCategory[] = [
  GEN_TEXT_MENU_CATEGORY,
  EDIT_TEXT_MENU_CATEGORY,
  CONTENT_MENU_CATEGORY,
  BUSINESS_MENU_CATEGORY,
  MARKETING_MENU_CATEGORY,
];
